import ajax from '../http/ajax'

export const getRegion = data => {
    return ajax.get('getAreaList', {
        region_type: data.region_type,
        id: data.id
    })
}

// 活动统计
export const addVisitLog = data => {
    return ajax.get('addVisitLog', data)
}

// pageNotFound页面获取最新活动
export const getNewlyActivity = data => {
    return ajax.get('getNewlyActivity', data)
}
